"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fedopsLogger = exports.FEDOPS_LOGGER_ID = void 0;
const fedops_logger_1 = require("@wix/fedops-logger");
exports.FEDOPS_LOGGER_ID = 'payment-methods-banner';
exports.fedopsLogger = (0, fedops_logger_1.create)(exports.FEDOPS_LOGGER_ID);
//# sourceMappingURL=index.js.map